import { Grid } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledImageGrid = styled(Grid)(({ theme, image }) => ({
  borderTopRightRadius: 8,
  borderTopLeftRadius: 8,
  color: theme.palette.grey[50],
  textAlign: "center",
  minHeight: "220px",
  backgroundImage: `url(${image})`,
  backgroundPosition: "center",
  backgroundSize: "cover",
  marginBottom: 25
}))

export const StyledButtonGrid = styled(Grid)(({ theme }) => ({
  marginBottom: 25,
  textAlign: "center"
}))
